import React from 'react'

const Assignment = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.6 12.25L5.45 10.1C5.26667 9.91667 5.03333 9.825 4.75 9.825C4.46667 9.825 4.23333 9.91667 4.05 10.1C3.86667 10.2833 3.775 10.5167 3.775 10.8C3.775 11.0833 3.86667 11.3167 4.05 11.5L6.9 14.35C7.08333 14.5333 7.31667 14.625 7.6 14.625C7.88333 14.625 8.11667 14.5333 8.3 14.35L13.95 8.7C14.1333 8.51667 14.225 8.28333 14.225 8C14.225 7.71667 14.1333 7.48333 13.95 7.3C13.7667 7.11667 13.5333 7.025 13.25 7.025C12.9667 7.025 12.7333 7.11667 12.55 7.3L7.6 12.25ZM2 20C1.45 20 0.979 19.8043 0.587 19.413C0.195667 19.021 0 18.55 0 18V4C0 3.45 0.195667 2.979 0.587 2.587C0.979 2.19567 1.45 2 2 2H6.2C6.41667 1.4 6.77933 0.916667 7.288 0.55C7.796 0.183333 8.36667 0 9 0C9.63333 0 10.2043 0.183333 10.713 0.55C11.221 0.916667 11.5833 1.4 11.8 2H16C16.55 2 17.021 2.19567 17.413 2.587C17.8043 2.979 18 3.45 18 4V18C18 18.55 17.8043 19.021 17.413 19.413C17.021 19.8043 16.55 20 16 20H2ZM9 3.25C9.21667 3.25 9.396 3.179 9.538 3.037C9.67933 2.89567 9.75 2.71667 9.75 2.5C9.75 2.28333 9.67933 2.104 9.538 1.962C9.396 1.82067 9.21667 1.75 9 1.75C8.78333 1.75 8.60433 1.82067 8.463 1.962C8.321 2.104 8.25 2.28333 8.25 2.5C8.25 2.71667 8.321 2.89567 8.463 3.037C8.60433 3.179 8.78333 3.25 9 3.25Z"
        fill="#3249D7"
      />
    </svg>
  )
}

export default Assignment
